function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 540,
  height: 455.294,
  fill: "#F5FDFF"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 533.647,
  height: 463.765,
  fill: "#F8F8F8"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_131_88)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_131_88)"
}, /*#__PURE__*/React.createElement("rect", {
  y: -2.11768,
  width: 364.235,
  height: 345.176,
  fill: "#333333"
})));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 300.706,
  height: 279.529,
  fill: "#CCCCCC"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  width: 300.706,
  height: 279.529,
  fill: "#CCCCCC"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_131_88)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.9,
  d: "M-87.0465 -147.455L369.212 181.62L-143.904 412.214L-87.0465 -147.455Z",
  fill: "#F8F8F8"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_131_88)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 274.235,
  y: 28.5881,
  width: 232.941,
  height: 453.176,
  rx: 25,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  x: 284.823,
  y: 38.1177,
  width: 211.765,
  height: 434.118,
  rx: 21,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M284.823 59.1177C284.823 47.5197 294.226 38.1177 305.823 38.1177H475.588C487.186 38.1177 496.588 47.5197 496.588 59.1177V83.6471H284.823V59.1177Z",
  fill: "#2896C9"
}), /*#__PURE__*/React.createElement("rect", {
  x: 298.588,
  y: 55.0588,
  width: 13.7647,
  height: 2.11765,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 298.588,
  y: 60.353,
  width: 13.7647,
  height: 2.11765,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 298.588,
  y: 65.647,
  width: 13.7647,
  height: 2.11765,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 284.823,
  y: 83.647,
  width: 211.765,
  height: 211.765,
  fill: "#333333"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 390.706,
  cy: 177.882,
  r: 36,
  fill: "#2896C9"
}), /*#__PURE__*/React.createElement("rect", {
  x: 298.588,
  y: 271.059,
  width: 184.235,
  height: 6.35294,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  x: 346.235,
  y: 313.412,
  width: 127.059,
  height: 6.35294,
  fill: "#CCCCCC"
}), /*#__PURE__*/React.createElement("rect", {
  x: 346.235,
  y: 363.177,
  width: 127.059,
  height: 6.35294,
  fill: "#CCCCCC"
}), /*#__PURE__*/React.createElement("rect", {
  x: 346.235,
  y: 412.941,
  width: 127.059,
  height: 6.35294,
  fill: "#CCCCCC"
}), /*#__PURE__*/React.createElement("rect", {
  x: 346.235,
  y: 327.177,
  width: 110.118,
  height: 6.35294,
  fill: "#CCCCCC"
}), /*#__PURE__*/React.createElement("rect", {
  x: 346.235,
  y: 376.941,
  width: 110.118,
  height: 6.35294,
  fill: "#CCCCCC"
}), /*#__PURE__*/React.createElement("rect", {
  x: 346.235,
  y: 426.706,
  width: 110.118,
  height: 6.35294,
  fill: "#CCCCCC"
}), /*#__PURE__*/React.createElement("rect", {
  x: 298.588,
  y: 263.647,
  width: 8.47059,
  height: 20.1176,
  rx: 4,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M403.412 177.882L384.353 190.72L384.353 165.045L403.412 177.882Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 317.647,
  cy: 324,
  r: 13.7647,
  fill: "#CCCCCC"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 317.647,
  cy: 373.765,
  r: 13.7647,
  fill: "#CCCCCC"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 317.647,
  cy: 423.529,
  r: 13.7647,
  fill: "#CCCCCC"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M221.826 197.468C207.927 183.568 200.118 164.716 200.118 145.059C200.118 125.402 207.927 106.549 221.826 92.6497L274.235 145.059L221.826 197.468Z",
  fill: "#D9D9D9"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask2_131_88)"
}, /*#__PURE__*/React.createElement("circle", {
  r: 58.0441,
  transform: "matrix(-1 0 0 1 274.897 147.044)",
  stroke: "#808080",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("circle", {
  r: 40.8382,
  transform: "matrix(-1 0 0 1 274.897 147.044)",
  stroke: "#808080",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("circle", {
  r: 22.3088,
  transform: "matrix(-1 0 0 1 274.897 147.044)",
  stroke: "#808080",
  strokeWidth: 7
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M107.275 154.211C107.275 146.19 103.859 110.167 118.868 111.384C129.032 112.208 130.799 138.087 131.587 144.39C133.424 159.087 133.697 176.265 129.011 190.598C118.138 223.858 138.011 121.044 146.399 87.0723C153.298 59.134 152.749 144.437 152.196 173.209C152.033 181.648 150.747 156.372 150.747 147.932C150.747 144.994 149.259 131.592 155.094 138.594C156.523 140.308 161.968 151.459 163.788 145.678C164.603 143.089 164.777 120.722 166.686 120.722C170.984 120.722 173.23 155.452 173.931 130.221C174.102 124.063 195.976 127.073 201.463 123.781",
  stroke: "#333333",
  strokeWidth: 7,
  strokeLinecap: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_131_88",
  x: -10,
  y: -8.11768,
  width: 384.235,
  height: 365.177,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_131_88"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_131_88",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_131_88",
  x: 259.235,
  y: 13.5881,
  width: 262.941,
  height: 483.177,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_131_88"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_131_88",
  result: "shape"
})));

function SvgFeature2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 497,
    viewBox: "0 0 540 497",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_131_88",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 534,
    height: 464
  }, _ref3), _ref4, _ref5, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_131_88",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 301,
    height: 280
  }, _ref6), _ref7, _ref8, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_131_88",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 92,
    width: 75,
    height: 106
  }, _ref9), _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2);
export default __webpack_public_path__ + "static/media/feature2.1d938e7d.svg";
export { ForwardRef as ReactComponent };